module.exports = __webpack_public_path__ + "img/mobile-top.38320717.png";